import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

const kycService = {
  // Admin methods
  getAllKYCSubmissions: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE_URL}/api/kyc/admin/all${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: api.getAuthHeaders(),
      });

      const data = await response.json();

      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error fetching KYC submissions';
    }
  },

  getKYCStatistics: async () => {
    try {
      console.log('KYC Service - Fetching statistics from:', `${API_BASE_URL}/api/kyc/admin/statistics`);
      const response = await fetch(`${API_BASE_URL}/api/kyc/admin/statistics`, {
        method: 'GET',
        headers: api.getAuthHeaders(),
      });

      console.log('KYC Service - Statistics response status:', response.status);
      const data = await response.json();
      console.log('KYC Service - Statistics response data:', data);

      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      console.error('KYC Service - Statistics error:', error);
      throw error.message || 'Error fetching KYC statistics';
    }
  },

  getKYCSubmissionById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/admin/${id}`, {
        method: 'GET',
        headers: api.getAuthHeaders(),
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error fetching KYC submission';
    }
  },

  verifyKYCApplication: async (id, adminNotes = '', targetTier = 3) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/admin/${id}/verify`, {
        method: 'POST',
        headers: {
          ...api.getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ adminNotes, targetTier }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error verifying KYC application';
    }
  },

  rejectKYCApplication: async (id, rejectionReason, rejectionNotes = '') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/admin/${id}/reject`, {
        method: 'POST',
        headers: {
          ...api.getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          rejectionReason,
          rejectionNotes
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error rejecting KYC application';
    }
  },

  // User methods
  getUserKYCStatus: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/user/status`, {
        method: 'GET',
        headers: api.getAuthHeaders(),
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error fetching KYC status';
    }
  },

  submitKYCApplication: async (formData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/user/submit`, {
        method: 'POST',
        headers: {
          'x-auth-token': JSON.parse(localStorage.getItem('user')).token,
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error submitting KYC application';
    }
  },

  updateKYCApplication: async (formData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/kyc/user/update`, {
        method: 'PUT',
        headers: {
          'x-auth-token': JSON.parse(localStorage.getItem('user')).token,
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }
      return data;
    } catch (error) {
      throw error.message || 'Error updating KYC application';
    }
  }
};

export default kycService; 